import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { setSettingsParams } from '@/utils';

const APIBaseURL = import.meta.env.VITE_DASHBOARD_API_ENDPOINT;

export const settingsApi = createApi({
  reducerPath: 'settingsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${APIBaseURL}/api/settings`,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as ReduxStoreState).auth.token;
      if (token) {
        headers.set('Authorization', token);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    fetchDBSettings: builder.query<ISettings[], IUserPortal>({
      query: (arg) => {
        const groupID = arg?.pvActiveGroupID;
        const userId = arg?.id;
        const params = setSettingsParams({
          pvSettingType: 'dashboard3Settings',
          pvAccountID: Number(userId),
          pvGroupID: groupID,
        });
        return { url: '', params };
      },
    }),
    fetchIncSettings: builder.query<ISettings[], IUserPortal>({
      query: (arg) => {
        const userId = arg?.id ?? 0;
        const params = setSettingsParams({
          pvSettingType: 'selectedIncidents',
          pvAccountID: Number(userId),
        });
        return { url: '', params };
      },
    }),
    fetchUserAllSettings: builder.query<ISettings[], number>({
      query: (userId) => {
        const params = setSettingsParams({ pvAccountID: Number(userId) });
        return { url: '', params };
      },
    }),
    putDbSettings: builder.mutation<ISettings, Partial<ISettings>>({
      query: (body) => ({
        url: '/dashboard',
        method: 'PUT',
        body,
      }),
    }),
  }),
});

export const {
  useFetchDBSettingsQuery,
  useFetchIncSettingsQuery,
  useFetchUserAllSettingsQuery,
  usePutDbSettingsMutation,
} = settingsApi;
